var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('MainText',{attrs:{"mainHeader":_vm.text.mainHeader,"mainStory":_vm.text.mainStory,"mainUpdate":_vm.text.mainUpdate}}),_c('LunchTables'),_c('OtherTables')],1)}
var staticRenderFns = []

export { render, staticRenderFns }